import { render, staticRenderFns } from "./pwdFrom.vue?vue&type=template&id=24f689a7&scoped=true&"
import script from "./pwdFrom.vue?vue&type=script&lang=js&"
export * from "./pwdFrom.vue?vue&type=script&lang=js&"
import style0 from "./pwdFrom.vue?vue&type=style&index=0&id=24f689a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f689a7",
  null
  
)

export default component.exports